import { call, put, takeLatest } from 'redux-saga/effects';

import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { GET_LEADERBOARD, GET_LEADERBOARD_SUCCESS } from './leaderboard.types';
import { LeaderboardService } from './leaderboard.service';


function* getLeaderBoard(action) {
  yield put(httpRequestsOnErrorsActions.removeError(action.type));
  yield put(httpRequestsOnLoadActions.appendLoading(action.type));

  try {
    const res = yield call(LeaderboardService.getLeaderboard);
    yield put({
      type: GET_LEADERBOARD_SUCCESS,
      payload: { history: res.data },
    });
  } catch (err) {
    yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
  }
}

export const watchLeaderboard = function* watchHistorySaga() {
  yield takeLatest(GET_LEADERBOARD, getLeaderBoard);
};